import type { FieldIssueParams } from './FieldIssueParams'
import { fieldNameKey } from './fieldNameKey'
import { isFieldName } from './isFieldName'
import type { PresentationScalar } from './PresentationScalar'
import type { TranslateFn } from './TranslateFn'

const TOKEN_PARAMS: ReadonlySet<string> = new Set([
  'allowed_values',
  'current_status',
  'other_field',
  'other_fields',
  'requested_status'
])

const presentToken = (token: string, t: TranslateFn): string =>
  isFieldName(token) ? t(fieldNameKey[token]) : token.replace(/[_.]/g, ' ')

const presentParam = (
  name: string,
  value: FieldIssueParams[string],
  t: TranslateFn
): PresentationScalar => {
  const isToken = TOKEN_PARAMS.has(name)
  if (typeof value === 'object') {
    return (isToken ? value.map((token) => presentToken(token, t)) : value).join(', ')
  }
  return isToken && typeof value === 'string' ? presentToken(value, t) : value
}

/** Interpolation values for a field issue's params: lists joined, known fields by their localized label, other tokens spelled as words. */
export const presentFieldIssueParams = (
  params: FieldIssueParams | undefined,
  t: TranslateFn
): Record<string, PresentationScalar> =>
  Object.fromEntries(
    Object.entries(params ?? {}).map(([name, value]) => [name, presentParam(name, value, t)])
  )
